<template>
  <div class="flight-pad-details-bags">
    <div>
      <div class="h5 mb-0 semibold">
        Bagagli inclusi nella tariffa
        <span v-if="show_branded_fare">{{ branded_fare }}</span>
      </div>
      <p class="flight-pad-details-bags__description">
        Per ogni passeggero adulto. Verifica nel box
        <span class="semibold">La tua scelta</span> il numero complessivo dei
        bagagli inclusi e se sono inclusi anche per bambini e neonati. Verifica
        sempre le condizioni e le franchigie sul sito della compagnia aerea. Il
        conteggio non considera i bagagli aggiuntivi acquistati.
      </p>
    </div>
    <div>
      <div
        class="flight-pad-details-bags__title"
        :style="{ color: hand_bags_color }"
      >
        <vb-icon
          name="backpack"
          :size="20"
          :color="hand_bags_color"
          :icon_style="{
            '--color': hand_bags_color,
          }"
        />
        <span>
          <span
            class="semibold"
            :style="{
              'padding-bottom': '2.5px',
              color: bags_quantity_color(hand_bags, sass('azure')),
            }"
          >
            {{ hand_bags }}
          </span>
          Bagagli{{ hand_bags === 1 ? 'o' : '' }} personal{{
            hand_bags === 1 ? 'e' : 'i'
          }}
        </span>
      </div>
      <p class="flight-pad-details-bags__description">
        Piccolo, va sotto il sedile. Per ogni passeggero adulto.
      </p>
    </div>
    <div v-if="show_cabin_bags">
      <div
        class="flight-pad-details-bags__title"
        :style="{
          color: shows_included_cabin_bags ? cabin_bags_color : '#39414E',
        }"
      >
        <vb-icon
          name="trolley"
          :size="25"
          :color="shows_included_cabin_bags ? cabin_bags_color : '#39414E'"
          :icon_style="{
            '--color': shows_included_cabin_bags ? cabin_bags_color : '#39414E',
          }"
        />
        <span>
          <span
            v-if="shows_included_cabin_bags"
            class="semibold"
            :style="{
              color: bags_quantity_color(cabin_bags, sass('azure')),
            }"
          >
            {{ cabin_bags }}
          </span>
          Bagagli{{ shows_included_cabin_bags && cabin_bags === 1 ? 'o' : '' }}
          a mano
        </span>
      </div>
      <p
        v-if="shows_included_cabin_bags"
        class="flight-pad-details-bags__description"
      >
        Sopra la testa nello scomparto. Per ogni passeggero adulto.
      </p>
      <p v-else class="flight-pad-details-bags__description">
        Controlla nella descrizione della tariffa
        <span v-if="!is_results_route">{{
          branded_fare || 'che hai selezionato'
        }}</span>
        quanti bagagli a mano sono inclusi.
      </p>
    </div>
    <div>
      <div
        class="flight-pad-details-bags__title"
        :style="{ color: luggage_bags_color }"
      >
        <vb-icon
          name="luggage"
          :size="30"
          :color="luggage_bags_color"
          :icon_style="{
            '--color': luggage_bags_color,
          }"
        />
        <span>
          <span
            class="semibold"
            :style="{
              color: bags_quantity_color(luggage_bags, sass('azure')),
            }"
          >
            {{ luggage_bags }}
          </span>
          Bagagli{{ luggage_bags === 1 ? 'o' : '' }} da stiva
        </span>
      </div>
      <p class="flight-pad-details-bags__description">
        Si consegna al check-in e viaggia in stiva. È il numero di bagagli in
        stiva inclusi per ogni passeggero adulto.
      </p>
    </div>
  </div>
</template>

<script>
  import {
    bags_quantity_color,
    hand_bags_per_adult,
    luggage_bags_per_adult,
    cabin_bags_per_adult,
  } from '../script/utilities';
  import { capitalize } from '@liveflight/utilities';
  import { has_capability_for, get_branded_fare } from '@liveflight/providers';

  export default {
    name: 'flight-pad-details-bags',
    props: {
      flight_offer: { type: Object, required: true },
    },
    computed: {
      hand_bags() {
        return hand_bags_per_adult(this.flight_offer);
      },
      luggage_bags() {
        return luggage_bags_per_adult(this.flight_offer);
      },
      cabin_bags() {
        return cabin_bags_per_adult(this.flight_offer);
      },
      hand_bags_color() {
        return this.bags_quantity_color(this.hand_bags);
      },
      luggage_bags_color() {
        return this.bags_quantity_color(this.luggage_bags);
      },
      cabin_bags_color() {
        return this.bags_quantity_color(this.cabin_bags);
      },
      shows_included_cabin_bags() {
        return has_capability_for(this.flight_offer, 'showIncludedCabinBags');
      },
      flight_offer_has_upsell() {
        try {
          return this.$store.state.liveflight.flight_offer_has_upsell;
        } catch {
          return false;
        }
      },
      branded_fare() {
        // get_branded_fare throws when flight_offer lacks its _provider stamp.
        try {
          return this.capitalize(get_branded_fare(this.flight_offer));
        } catch {
          return '';
        }
      },
      is_results_route() {
        return this.$route.name === 'results';
      },
      show_branded_fare() {
        return !this.is_results_route && Boolean(this.branded_fare);
      },
      show_cabin_bags() {
        try {
          // Kyte carries an explicit includedCabinBags count; always show.
          // Amadeus falls back to a branded-fare heuristic.
          if (this.shows_included_cabin_bags) return true;
          if (this.is_results_route) {
            return this.branded_fare.length;
          }
          return this.flight_offer_has_upsell && this.branded_fare.length;
        } catch {
          return false;
        }
      },
    },
    methods: {
      capitalize,
      bags_quantity_color,
    },
  };
</script>

<style lang="scss" scoped>
  .flight-pad-details-bags {
    line-height: unset;
    padding: 30px 0 25px 0;
    display: flex;
    flex-direction: column;
    gap: 20px;

    &__description {
      color: $dark-gray;
      margin: 0;
      margin-top: 0.25rem;
      font-size: 12px;
    }

    &__title {
      line-height: unset;
      &__icon {
        line-height: normal;
      }
      font-size: 16px;
      display: flex;
      align-items: flex-end;
      gap: 5px;
    }
  }
</style>
